// extracted by mini-css-extract-plugin
export default {"custom-body":"styles_custom-body__zU3uH","btn-red":"styles_btn-red__2+RKk","select_box":"styles_select_box__qgUtJ"};